module.exports = __webpack_public_path__ + "map-marker2.png?2d4920e941e1e8944c3dd340b9e85ccd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/map-marker2.png
// module id = 545
// module chunks = 2